import { BMDLabInterpretation, LabItemBMDAction, ValiditySeverity } from "@fusion-advantage/formlib"
import L1Select from "../../form/l1/L1Select"
import L1TextField from "../../form/l1/L1TextField"
import L2ControlGrid from "../../form/l2/L2ControlGrid"
import L2ControlGridLayout from "../../form/l2/L2ControlGridLayout"

interface V2L3LabsTableBmdControlProps {
	action: LabItemBMDAction|null
	onChange: (action: Partial<LabItemBMDAction>) => void
	severity?: ValiditySeverity
}

const V2L3LabsTableBmdControl = ({action, onChange, severity}: V2L3LabsTableBmdControlProps) => {
	return (
		<L2ControlGrid layout={L2ControlGridLayout.FlexColumn} columnCount={3}>
			<div>
				<div>Density Index (g/cm^2)</div>
				<L1TextField 
					inputType='number'
					size={undefined}
					value={action?.densityIndex}
					onChange={(e) => onChange({densityIndex: e.target.value})}
				/>
			</div>
			<div>
				<div>Cortical bone thickness (mm)</div>
				<L1TextField 
					inputType='number'
					size={undefined}
					value={action?.corticalBoneThickness}
					onChange={(e) => onChange({corticalBoneThickness: e.target.value})}
				/>
			</div>
			<div>
				<div>Interpretation (probability of osteoporosis)</div>
				<L1Select
					value={action?.interpretation}
					onChange={(e) => onChange({interpretation: e.target.value})}
					padding="8px"
					expand
				>
					<option value={BMDLabInterpretation.LowRisk}>Low risk</option>
					<option value={BMDLabInterpretation.IntermediateRisk}>Intermediate risk</option>
					<option value={BMDLabInterpretation.HighRisk}>High risk</option>
				</L1Select>
			</div>
		</L2ControlGrid>
	)
}

export default V2L3LabsTableBmdControl